export default __webpack_public_path__ + "media/images/images_v2/iui/toggle-b24b42d94bce9175d0f9b5434cd0368f.png";